import { useEffect } from 'react';
import useBreadcrumb from 'hooks/useBreadcrumb';
import CreateManifestForm from '../components/create-manifest-form/CreateManifestForm';
import { useLocation } from 'react-router-dom';

const CreateManifestPage = () => {
    const { setBreadcrumbRoutes } = useBreadcrumb();
    const location = useLocation();
    const previousLocation = location.pathname.split('/')[1];

    useEffect(() => {
        setBreadcrumbRoutes([
            {
                breadcrumbName: 'Home',
                path: '/home',
            },
            {
                breadcrumbName: 'Manifests',
                path: `../${previousLocation}`,
            },
            {
                breadcrumbName: 'New Manifest',
                path: '',
            },
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setBreadcrumbRoutes]);

    return <CreateManifestForm />;
};

export default CreateManifestPage;
